/* eslint-disable @typescript-eslint/no-explicit-any */
import {postFormData} from '../technique/api';

export const sinistreBDL = () => ({
  registerAccidentVoyage: (data: any) =>
    postFormData('common/sinistre/accident-voyage', data),
  registerAutoMoto: (data: any) =>
    postFormData('common/sinistre/auto-moto', data),
  registerFamille: (data: any) => postFormData('common/sinistre/famille', data),
  registerHabitation: (data: any) =>
    postFormData('common/sinistre/habitation', data),
});
